// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sri-venkateshwara {
  /* Thumb (red when OFF) */
  /* Checked (ON) state */
  /* Thumb when checked */
}
.sri-venkateshwara .deleteIconAccordion {
  margin-top: -40px;
}
.sri-venkateshwara .custom-switch {
  width: 2.5rem;
  height: 1rem;
  background-color: #ccc; /* Track color when OFF */
  border-radius: 2rem;
  background-image: none;
  box-shadow: none;
  position: relative;
  transition: background-color 0.2s ease-in-out;
}
.sri-venkateshwara .custom-switch:hover {
  cursor: pointer;
}
.sri-venkateshwara .custom-switch::before {
  content: "";
  position: absolute;
  height: 0.8rem;
  width: 0.8rem;
  left: 0.2rem;
  top: 0.08rem;
  background-color: red;
  border-radius: 50%;
  transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
  box-shadow: none;
}
.sri-venkateshwara .custom-switch:checked {
  background-color: rgb(119, 237, 119) !important;
}
.sri-venkateshwara .custom-switch:checked::before {
  transform: translateX(1.3rem); /* Adjusted for new width */
  background-color: green;
}`, "",{"version":3,"sources":["webpack://./src/Pages/customer_app/Customer_V2/Style/customer_v2.scss"],"names":[],"mappings":"AAAA;EAoBE,yBAAA;EAcA,uBAAA;EAKA,uBAAA;AAnCF;AAHE;EACE,iBAAA;AAKJ;AADE;EACE,aAAA;EACA,YAAA;EACA,sBAAA,EAAA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;AAGJ;AAFI;EACE,eAAA;AAIN;AACE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,yEAAA;EACA,gBAAA;AACJ;AAGE;EACE,+CAAA;AADJ;AAKE;EACE,6BAAA,EAAA,2BAAA;EACA,uBAAA;AAHJ","sourcesContent":[".sri-venkateshwara {\n  .deleteIconAccordion {\n    margin-top: -40px;\n  }\n\n  //order booking  OrderSchedulingModal\n  .custom-switch {\n    width: 2.5rem;\n    height: 1rem;\n    background-color: #ccc; /* Track color when OFF */\n    border-radius: 2rem;\n    background-image: none;\n    box-shadow: none;\n    position: relative;\n    transition: background-color 0.2s ease-in-out;\n    &:hover{\n      cursor: pointer;\n    }\n  }\n\n  /* Thumb (red when OFF) */\n  .custom-switch::before {\n    content: \"\";\n    position: absolute;\n    height: 0.8rem;\n    width: 0.8rem;\n    left: 0.2rem;\n    top: 0.08rem;\n    background-color: red;\n    border-radius: 50%;\n    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;\n    box-shadow: none;\n  }\n\n  /* Checked (ON) state */\n  .custom-switch:checked {\n    background-color: rgb(119 237 119) !important;  \n  }\n\n  /* Thumb when checked */\n  .custom-switch:checked::before {\n    transform: translateX(1.3rem); /* Adjusted for new width */\n    background-color: green;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
